import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  useMediaQuery,
  Card,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  Grid2,
  Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useParams } from "react-router-dom";
import { RequestError, useApi } from "../../services";
import { ErrorOnDialog, gaugeColor, GISTMIndicadorAderencia, GISTMRequisitoItem } from "../../components";
import { GISTMRequisitos } from "../../services/api/gistm";
import { Gauge, gaugeClasses } from "@mui/x-charts";

export const GISTMAderencia: React.FC = () => {
  const api = useApi();
  const theme = useTheme();
  const { barragem } = useParams<{ barragem: string; }>();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down(1100));

  const [error, setError] = useState<RequestError>();
  const [requisitos, setRequisitos] = useState<GISTMRequisitos[]>([]);
  const [topicos, setTopicos] = useState([
    {
      id: 1,
      expanded: false,
      titulo: "COMUNIDADES AFETADAS",
      principios: [{
        id: 1,
        descricao: "RESPEITAR OS DIREITOS DE PESSOAS AFETADAS PELO PROJETO E PROCURAR ENGAJÁ-LAS SIGNIFICATIVAMENTE EM TODAS AS FASES DO CICLO DE VIDA DAS ESTRUTURAS DE DISPOSIÇÃO DE REJEITOS, INCLUSIVE NA FASE DE FECHAMENTO",
      }],
      cor: "#d0e9ff",
    },
    {
      id: 2,
      expanded: false,
      titulo: "BASE INTEGRADA DE CONHECIMENTOS",
      principios: [
        {
          id: 2,
          descricao: "DESENVOLVER E MANTER UMA BASE DE CONHECIMENTOS INTERDISCIPLINAR PARA APOIAR UMA GESTÃO SEGURA DOS REJEITOS AO LONGO DE TODO O CICLO DE VIDA DAS ESTRUTURAS DE DISPOSIÇÃO DE REJEITOS, INCLUSIVE NA FASE DE FECHAMENTO.",
        },
        {
          id: 3,
          descricao: "USAR TODOS OS ELEMENTOS DA BASE DE CONHECIMENTOS - SOCIAIS, AMBIENTAIS, ECONÔMICOS E TÉCNICOS LOCAIS - PARA SUBSIDIAR DECISÕES AO LONGO DE TODO O CICLO DE VIDA DAS ESTRUTURAS DE DISPOSIÇÃO DE REJEITOS, INCLUSIVE NA FASE DE FECHAMENTO.",
        },
      ],
      cor: "#dfffd0",
    },
    {
      id: 3,
      expanded: false,
      titulo: "PROJETO, CONSTRUÇÃO, OPERAÇÃO E MONITORAMENTO DE ESTRUTURAS DE DISPOSIÇÃO DE REJEITOS",
      principios: [
        {
          id: 4,
          descricao: "PRINCÍPIO 4: DESENVOLVER PLANOS E CRITÉRIOS DE PROJETO PARA A ESTRUTURAS DE DISPOSIÇÃO DE REJEITOS NO SENTIDO DE MINIMIZAR RISCOS EM TODAS AS FASES DO SEU CICLO DA VIDA, INCLUSIVE NAS FASES DE FECHAMENTO E PÓS-FECHAMENTO.",
        },
        {
          id: 5,
          descricao: "DESENVOLVER UM PROJETO ROBUSTO QUE INTEGRE A BASE DE CONHECIMENTOS E MINIMIZE O RISCO DE FALHAS QUE POSSAM ATINGIR AS PESSOAS E O MEIO AMBIENTE EM TODAS AS FASES DO CICLO DE VIDA DAS ESTRUTURAS DE DISPOSIÇÃO DE REJEITOS, INCLUSIVE NAS FASES DE FECHAMENTO E PÓS-FECHAMENTO.",
        },
        {
          id: 6,
          descricao: "PLANEJAR, CONSTRUIR E OPERAR A ESTRUTURA DE DISPOSIÇÃO DE REJEITOS DE MODO A GARANTIR A GESTÃO DE RISCOS EM TODAS AS FASES DO CICLO DE VIDA DAS ESTRUTURAS DE DISPOSIÇÃO DE REJEITOS, INCLUINDO NAS FASES DE FECHAMENTO E PÓS-FECHAMENTO.",
        },
        {
          id: 7,
          descricao: "PROJETAR, IMPLEMENTAR E OPERAR SISTEMAS DE MONITORAMENTO PARA GERENCIAR RISCOS EM TODAS AS FASES DO CICLO DE VIDA DAS ESTRUTURAS DE DISPOSIÇÃO DE REJEITOS, INCLUSIVE NA FASE DE FECHAMENTO.",
        },
      ],
      cor: "#ffe7d0",
    },
    {
      id: 4,
      expanded: false,
      titulo: "GESTÃO E GOVERNANÇA",
      principios: [
        {
          id: 8,
          descricao: "ESTABELECER POLÍTICAS, SISTEMAS E RESPONSABILIDADES PARA APOIAR A SEGURANÇA E A INTEGRIDADE DAS ESTRUTURAS DE DISPOSIÇÃO DE REJEITOS.",
        },
        {
          id: 9,
          descricao: "DESIGNAR E HABILITAR UM ENGENHEIRO DE REGISTRO.",
        },
        {
          id: 10,
          descricao: "ESTABELECER E IMPLEMENTAR NÍVEIS DE REVISÃO COMO PARTE DE UM SISTEMA ROBUSTO DE GESTÃO DA QUALIDADE E DE RISCOS PARA TODAS AS FASES DO CICLO DE VIDA DAS ESTRUTURAS DE DISPOSIÇÃO DE REJEITOS, INCLUSIVE NA FASE DE FECHAMENTO.",
        },
        {
          id: 11,
          descricao: "DESENVOLVER UMA CULTURA ORGANIZACIONAL QUE PROMOVA A APRENDIZAGEM, A COMUNICAÇÃO E O RECONHECIMENTO PRECOCE DE PROBLEMAS.",
        },
        {
          id: 12,
          descricao: "ESTABELECER UM PROCESSO PARA A APRESENTAÇÃO DE DENÚNCIAS E RESPOSTA A PREOCUPAÇÕES E IMPLEMENTAR MEDIDAS DE PROTEÇÃO PARA DENUNCIANTES.",
        },
      ],
      cor: "#d0d8ff",
    },
    {
      id: 5,
      expanded: false,
      titulo: "RESPOSTA ÀS EMERGÊNCIAS E RECUPERAÇÃO DE LONGO PRAZO",
      principios: [
        {
          id: 13,
          descricao: "PREPARAR-SE PARA RESPOSTA ÀS EMERGÊNCIAS DIANTE DE FALHAS NAS ESTRUTURAS DE DISPOSIÇÃO DE REJEITOS.",
        },
        {
          id: 14,
          descricao: "PREPARAR-SE PARA UMA RECUPERAÇÃO DE LONGO PRAZO NA EVENTUALIDADE DE UMA FALHA CATASTRÓFICA.",
        },
      ],
      cor: "#ffffd0",
    },
    {
      id: 6,
      expanded: false,
      titulo: "DIVULGAÇÃO PÚBLICA E ACESSO À INFORMAÇÃO",
      principios: [
        {
          id: 15,
          descricao: "DIVULGAR PUBLICAMENTE E OFERECER ACESSO A INFORMAÇÕES SOBRE AS ESTRUTURAS DE DISPOSIÇÃO DE REJEITOS PARA APOIAR A PRESTAÇÃO DE CONTAS E RESPONSABILIZAÇÃO PÚBLICA.",
        },
      ],
      cor: "#ffd0e1",
    },
  ]);

  useEffect(() => {
    if (!barragem) return;
    api.gistm.getAllRequisitos(parseInt(barragem), 1, 1000).then(val => {
      if ("error" in val) {
        setError(val);
        return;
      }

      setRequisitos(val.items);
    });
  }, []);

  return (
    <>
      {error && <ErrorOnDialog
        error={error.error}
        open={Boolean(error)}
        message={error.message}
        onClose={() => setError(undefined)}
      />}

      <Box
        sx={{
          p: 0,
          gap: 2,
          display: "flex",
          overflow: "hidden",
          backgroundColor: "background.default",
          height: isMobileOrTablet ? "auto" : "100vh",
          flexDirection: isMobileOrTablet ? "column" : "row",
        }}
      >
        {/* Indicador + Acordeon */}
        <Box
          sx={{
            p: 2,
            gap: 2,
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >

          {/* Aderência */}
          <Card sx={{
            p: 2,
            boxShadow: 3,
            minHeight: 300,
            borderRadius: 2,
          }}>
            <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
              Aderência Geral
            </Typography>
            <GISTMIndicadorAderencia
              aderencia={
                requisitos.filter(val => val.aplicacao)
                  .reduce((acc, val, _, arr) => acc + (val.peso * 100) / arr.length, 0)}
              width={300}
            />
          </Card>

          {/* Acordeons */}
          <Card
            sx={{
              boxShadow: 3,
              borderRadius: 2,
              overflowY: "auto",
            }}
          >
            {topicos.map((topico, index) => (
              <Accordion
                key={topico.id}
                square
                disableGutters
                expanded={topico.expanded}
                onChange={(ev, expanded) => setTopicos(prev => prev.map(val => (val.id === topico.id ? ({ ...val, expanded }) : val)))}
                sx={{
                  bgcolor: topico.cor,
                  boxShadow: "none",
                  borderBottom: index === topicos.length - 1 ? "none" : "1px solid",
                  borderColor: "divider",
                  "&:before": { display: "none" },
                  "&.Mui-expanded": {
                    margin: 0,
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    fontWeight: 700,
                    borderColor: "divider",
                    borderBottom: "1px solid",
                  }}
                >
                  <Box sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}>
                    <Typography sx={{ fontWeight: 700 }}>
                      {topico.titulo}
                    </Typography>

                    <Box sx={{ width: 55, height: 55 }}>
                      <Gauge
                        width={55}
                        height={55}
                        cornerRadius="50%"
                        value={
                          requisitos.filter(val => (topico.principios.find(principio => principio.id === val.principio)) && val.aplicacao)
                            .reduce((acc, val, _, arr) => acc + (val.peso * 100) / arr.length, 0)
                        }
                        endAngle={110}
                        startAngle={-110}
                        text={
                          requisitos.filter(val => (topico.principios.find(principio => principio.id === val.principio)) && val.aplicacao)
                            .reduce((acc, val, _, arr) => acc + (val.peso * 100) / arr.length, 0).toFixed(0)
                        }
                        /* eslint-disable-next-line indent */
                        sx={(theme) => ({
                          [`& .${gaugeClasses.valueText}`]: {
                            fontSize: 12,
                            fontWeight: 700,
                          },
                          [`& .${gaugeClasses.valueArc}`]: {
                            fill: gaugeColor(
                              theme,
                              requisitos.filter(val => (topico.id === val.principio) && val.aplicacao)
                                .reduce((acc, val, _, arr) => acc + (val.peso * 100) / arr.length, 0)
                            ),
                          },
                          [`& .${gaugeClasses.referenceArc}`]: {
                            fill: theme.palette.text.disabled,
                          },
                        })}
                      />
                    </Box>
                  </Box>
                </AccordionSummary>

                <AccordionDetails sx={{ bgcolor: "background.paper", p: 0 }}>
                  <List dense disablePadding>
                    {topico.principios.map((num) => (
                      <ListItem
                        key={`${topico.id}-${num.id}`}
                        sx={{
                          pl: 3,
                          borderBottom: "1px dashed",
                          borderColor: "divider",
                        }}
                      >
                        <ListItemText
                          primaryTypographyProps={{
                            fontWeight: "bold",
                            fontSize: "0.9rem",
                            textAlign: "justify",
                          }}
                          primary={`${num.id} - ${num.descricao}`}
                        />
                      </ListItem>
                    ))}
                  </List>
                </AccordionDetails>
              </Accordion>
            ))}
          </Card>
        </Box>

        {/* Grid de requisitos */}
        <Box
          sx={{
            pr: 2,
            py: 2,
            flex: 2,
            display: "flex",
            overflowY: "auto",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, mb: 1, display: { xs: "none", sm: "block" } }}
          >
            Requisitos
          </Typography>

          <Divider flexItem />

          <Grid2
            container
            spacing={2}
            sx={{
              p: 1,
              flexGrow: 1,
              overflowY: "auto",
            }}
          >
            {requisitos.filter(val => {
              if (topicos.every(val => !val.expanded)) return true;
              if (topicos.find(top => top.principios.find(principio => principio.id === val.principio))?.expanded) return true;
              return false;
            }).map((requisito, index) => (
              <Grid2 size={{ xs: 12, sm: 6, md: 6 }} key={index}>
                <GISTMRequisitoItem key={requisito.id} initRequisito={requisito} bgColor={topicos.find(val => val.id === requisito.principio)?.cor} />
              </Grid2>
            ))}
          </Grid2>
        </Box>
      </Box >
    </>
  );
};
